export default __webpack_public_path__ + "static/media/ferz.7c41bd27.png";